import { LoadStatus } from 'Types';
import { SettingsActionTypes, SettingsActions } from './actions';
import { SettingsStateRecord } from './Types/SettingsStateRecord';
import { UserTypeAgnosticSettings } from './Types/UserTypeAgnosticSettings';

export type SettingsState = SettingsStateRecord<UserTypeAgnosticSettings>;

const initialState: SettingsState = {
    loadStatus: LoadStatus.INITIAL_STATE,
};

export const settingsReducer = (state = initialState, action: SettingsActionTypes): SettingsState => {
    switch (action.type) {
        case SettingsActions.LOAD_SETTINGS:
            return {
                ...state,
                loadStatus: LoadStatus.PENDING,
            };
        case SettingsActions.SET_SETTINGS:
            return {
                ...state,
                loadStatus: LoadStatus.LOADED,
                data: action.payload as UserTypeAgnosticSettings,
            };
        case SettingsActions.SET_ERROR:
            return {
                ...state,
                loadStatus: LoadStatus.ERROR,
                errorState: {
                    error: (action.payload as { errorMessage: string }).errorMessage,
                },
            };
        default:
            return state;
    }
};
